export const BankCard = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.66666 5.6237C1.66666 4.35805 2.69268 3.33203 3.95833 3.33203H16.0417C17.3073 3.33203 18.3333 4.35805 18.3333 5.6237V14.3737C18.3333 15.6393 17.3073 16.6654 16.0417 16.6654H3.95833C2.69268 16.6654 1.66666 15.6393 1.66666 14.3737V5.6237ZM5 8.1237C5 7.77852 5.27982 7.4987 5.625 7.4987H9.375C9.72017 7.4987 10 7.77852 10 8.1237C10 8.46888 9.72017 8.7487 9.375 8.7487H5.625C5.27982 8.7487 5 8.46888 5 8.1237ZM11.6667 8.1237C11.6667 7.77852 11.9465 7.4987 12.2917 7.4987H14.375C14.7202 7.4987 15 7.77852 15 8.1237V11.0404C15 11.3855 14.7202 11.6654 14.375 11.6654H12.2917C11.9465 11.6654 11.6667 11.3855 11.6667 11.0404V8.1237ZM5 10.6237C5 10.2785 5.27982 9.9987 5.625 9.9987H7.725C8.07018 9.9987 8.35 10.2785 8.35 10.6237C8.35 10.9689 8.07018 11.2487 7.725 11.2487H5.625C5.27982 11.2487 5 10.9689 5 10.6237Z"
      fill="currentColor"
    />
  </svg>
)

export default BankCard
